import { createContext, useCallback, useContext } from "react";
import { setFormData as setFormDataStore } from "./product-config-store";

export interface ProgressData {
  formData: Record<string, Record<string, unknown>>;
  currentStepId: string | null;
}

export interface ProgressContextValue extends ProgressData {
  updateFormData(stepId: string, data: Record<string, unknown>): void;
  isAnalyzing: boolean;
  setIsAnalyzing(value: boolean): void;
}

const noop = () => {};
const DEFAULT: ProgressContextValue = {
  formData: {},
  currentStepId: null,
  updateFormData: noop,
  isAnalyzing: false,
  setIsAnalyzing: noop,
};

export const ProgressContext = createContext<ProgressContextValue>(DEFAULT);

export function useProgress(): ProgressContextValue {
  return useContext(ProgressContext);
}

export function useProgressUpdater(
  setProgressData: React.Dispatch<React.SetStateAction<ProgressData>>,
): (stepId: string, data: Record<string, unknown>) => void {
  return useCallback(
    (stepId: string, data: Record<string, unknown>) => {
      setProgressData((prev) => {
        const nextFormData = { ...prev.formData, [stepId]: data };
        // Sync to module-level store immediately so shouldSkip callbacks
        // see the latest form data before the React render cycle completes.
        setFormDataStore(nextFormData);
        return { ...prev, formData: nextFormData };
      });
    },
    [setProgressData],
  );
}
